import { ChevronUpIcon } from '@chakra-ui/icons';
import {
  Button,
  Icon,
  IconButton,
  MenuButton,
  MenuButtonProps,
} from '@chakra-ui/react';

import { INavLink } from '../navigation-meta';
import { defaultStyle, selectedStyle } from './constant';

interface ISideMenuItemProps {
  link: INavLink;
  navPos: number;
  subNavPos?: number;
  currentPath?: string;
  collapsed?: boolean;
  isNested?: boolean;
  handleNavClick: (path?: string, navPos?: number) => void;
}

export const SideMenuItem = ({
  link,
  navPos,
  subNavPos,
  currentPath,
  collapsed,
  isNested,
  handleNavClick,
}: ISideMenuItemProps) => {
  const selected =
    link.path === currentPath || currentPath?.includes(`${link.path}/`);
  const props: Partial<MenuButtonProps> = {
    marginBottom: '1px',
    _active: selected ? undefined : defaultStyle,
    'aria-label': link.name,
    overflowY: 'hidden',

    fontSize: '12px',
    fontWeight: 500,
    onClick: () => handleNavClick(link.path, navPos),
    w: { base: '100%' },
    overflowX: 'hidden',
    h: '36px',
    px: 2,
    textAlign: collapsed ? 'center' : 'left',
    lineHeight: '36px',
    title: link.name,
    ...(selected ? selectedStyle : undefined),
  };

  if (collapsed) {
    return (
      <MenuButton
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        as={IconButton}
        icon={<Icon as={link.icon} h={4} w={4} />}
        iconSpacing={4}
        variant="auxiliary"
        {...props}
      ></MenuButton>
    );
  }

  const defaultStyles = {
    overFlowY: 'hidden',
    variant: 'auxiliary',
    fontSize: '12px',
    fontWeight: '500',
    h: '36px',
    px: '2',
    lineHeight: '36px',
  };

  return (
    <>
      {collapsed ? (
        <MenuButton
          {...defaultStyle}
          {...defaultStyles}
          _active={selected ? undefined : defaultStyle}
          as={IconButton}
          aria-label={link.name}
          icon={<Icon as={link.icon} h={4} w={4} />}
          onClick={() => handleNavClick(link.path, navPos)}
          w={{ base: '100%' }}
          textAlign="center"
          {...(selected ? selectedStyle : undefined)}
          title={link.name}
        />
      ) : (
        <MenuButton
          {...defaultStyle}
          {...defaultStyles}
          _active={selected ? undefined : defaultStyle}
          as={Button}
          aria-label={link.name}
          iconSpacing={4}
          rightIcon={
            link.subItem && link.subItem.length ? (
              <ChevronUpIcon
                boxSize={5}
                transform={`rotate(${subNavPos === navPos ? 0 : 90}deg)`}
                transition="transform 0.2s"
              />
            ) : undefined
          }
          leftIcon={
            collapsed || isNested ? undefined : (
              <Icon as={link.icon} boxSize={4} />
            )
          }
          onClick={() => handleNavClick(link.path, navPos)}
          w={{ base: '100%' }}
          textAlign="left"
          {...(selected ? selectedStyle : undefined)}
          title={link.name}
        >
          {link.name}
        </MenuButton>
      )}
    </>
  );
};
